module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-my-garage-03.5c42782.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-03.png
// module id = ZdlE
// module chunks = 0